import DOMPurify from "dompurify";
// eslint-disable-next-line no-restricted-imports
import parse from "html-react-parser";

type DOMPurifyConfig = Parameters<typeof DOMPurify.sanitize>[1];

export const safelyParseHtml = (str: string, options?: DOMPurifyConfig) => parse(DOMPurify.sanitize(str, options));
